
require('./utils/helpers.js');

// require('./vendor/vue');
require('./vendor/echo');
require('./vendor/lodash');
require('./vendor/axios');
require('./vendor/swal2');
require('./vendor/tooltip');

require('./utils/data-copy');
require('./utils/data-href');
require('./utils/data-method');
require('./utils/Notify');
require('./utils/Date');

import UriHelper from './utils/Uri';
window.Uri = (from) => {
    return new UriHelper(from);
}
